export const getMaxBookingTime = (value) => (value ? Math.floor(value) * 24 * 60 : null)
